import { render, staticRenderFns } from "./LeaderboardUserElement.vue?vue&type=template&id=4809e46b&scoped=true"
import script from "./LeaderboardUserElement.vue?vue&type=script&lang=js"
export * from "./LeaderboardUserElement.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardUserElement.vue?vue&type=style&index=0&id=4809e46b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4809e46b",
  null
  
)

export default component.exports